import { createFileRoute, redirect } from "@tanstack/react-router";

import { MachineApplicationsCard } from "@/features/Settings/machineApplications/MachineApplicationsCard";
import {
  machineAppsRouteRedirect,
  useMachineAppsAccess,
} from "@/features/Settings/machineAppsAccess";
import { SettingsPage } from "@/features/Settings/SettingsPage";
import { usePrivilegedModeStore } from "@/utils/privilegedMode";

export const Route = createFileRoute(
  "/_auth/settings/$siteId/machine-applications",
)({
  beforeLoad: ({ context, params }) => {
    const disabled = usePrivilegedModeStore.getState().disabled;
    const target = machineAppsRouteRedirect(
      context.auth,
      disabled,
      params.siteId,
    );
    if (target) throw redirect(target);
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { siteId } = Route.useParams();
  const canAccess = useMachineAppsAccess();

  return (
    <SettingsPage
      title="Machine Applications"
      description="Create machine applications for server-to-server API access."
      access={canAccess}
      data-testid="settings-machine-applications-page"
    >
      <MachineApplicationsCard siteId={siteId} />
    </SettingsPage>
  );
}
